import { useState, useRef } from 'react';

import BranchInfo from '../components/BranchInfo';
import BranchGoogleMaps from '../NewBranch/BranchGoogleMaps';

import { basicMsg } from '../../../../actions/swal_msg';
import { updateBranch } from '../../../../actions/admin/branch';

import { FieldValues } from '../../../../helpers/admin/branch/branch';
import { setPostalcodeInfo } from '../../../../helpers/shop/postalcodeHelper';
import { form1Validator } from '../../../../validators/Admin/Branch/BranchValidator';

import { BRANCH_FIELD_ERR } from '../../../../constants/admin/branch_constants';
import { GOOGLE_DRIVE_CDN, CHECKOUT_DISABLED_INPUT } from '../../../../constants/constants';

//MUI
import {
    Dialog, DialogContent, DialogTitle, Divider,
    FormControl, Grid, TextField, Button, MenuItem,
    FormHelperText, IconButton, DialogActions
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const EditBranch = ({
    openModal, setOpenModal, activeBranch, setActiveBranch,
    setBranches, setSnackbarData
}) => {
    const {
        _id, folderId, imgId,
        name, phone, mobile, email, address, postalCode,
        colony, city, state, links: { whatsapp, facebook, google_maps }
    } = activeBranch;
    const { number, message } = whatsapp;
    const { url } = facebook;

    const [loading, setLoading] = useState(false);

    const [inputErr, setInputErr] = useState(BRANCH_FIELD_ERR);
    const {
        address_err, pc_err, colony_err, city_err, state_err,
        wsp_number_err, wsp_message_err, facebook_url_err,
    } = inputErr;

    const name_ref = useRef();
    const phone_ref = useRef();
    const email_ref = useRef();
    const address_ref = useRef();
    const postalCode_ref = useRef();
    const city_ref = useRef();
    const state_ref = useRef();
    const wsp_number_ref = useRef();
    const wsp_message_ref = useRef();
    const facebook_url_ref = useRef();
    const place_id_ref = useRef();

    // objeto con referencias
    const sharedRefs = {
        name_ref, phone_ref, email_ref, address_ref, postalCode_ref,
        city_ref, state_ref, wsp_message_ref, wsp_number_ref, facebook_url_ref,
        place_id_ref
    };

    // información recuperada con el código postal
    const [colonies, setColonies] = useState([]);

    // deshabilitación de campos
    const [disabledFields, setDisabledFields] = useState(CHECKOUT_DISABLED_INPUT);
    const { cityInput, stateInput } = disabledFields;

    const handlePlaceAutofill = () => {
        setColonies([]);
        setDisabledFields(current => ({
            ...current,
            cityInput: false,
            stateInput: false
        }));
    };

    const handleClose = () => {
        setOpenModal(false);
    };

    const inputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        FieldValues({ name, value }, setActiveBranch, { inputErr, setInputErr });
    }

    // campo pierde foco
    const handleInputBlur = async ({ target }) => {
        if (target.name === 'postalCode')
            // busca información del CP ingresado
            setPostalcodeInfo(
                postalCode, setActiveBranch,
                setColonies, setDisabledFields
            );
    };

    // imagen de sucursal
    const [file, setFile] = useState('');
    const handleChange = ({ target }) => {
        if (target.files.length > 0) {
            const ImgFile = target.files[0];
            if (['image/jpeg', 'image/png', 'image/webp'].includes(ImgFile.type))
                setFile(ImgFile);
            else basicMsg('Imagen no compatible');
        }
    };

    // envío de formulario
    const submit = async (e) => {
        e.preventDefault();
        if (form1Validator({ ...activeBranch, file }, sharedRefs, 'update', setInputErr)) {
            setLoading(true);
            await updateBranch({ ...activeBranch, file }, updateListAndClose);
            setLoading(false);
        }
    };
    
    const updateListAndClose = (lastImgId) => {
        const model = {
            _id, folderId, imgId: lastImgId,
            title: name, phone, mobile, email,
            address: {
                street: address, colony,
                postalcode: postalCode, city, state
            },
            links: {
                whatsapp: { number, message },
                facebook: { url },
                googleMaps: { ...google_maps }
            }
        };
        setFile('');
        setBranches(e => e.map(
            u => (u._id === _id) ? model : u
        ));
        handleClose();
        setSnackbarData(e => ({
            ...e, open: true, message: 'Sucursal actualizada'
        }));
    };

    return (
        <Dialog
            open={openModal}
            onClose={handleClose}
            fullWidth={true}
            maxWidth='lg'
            sx={{ zIndex: (theme) => theme.zIndex.modal - 1 }}
        >
            <DialogTitle>
                Editar sucursal
            </DialogTitle>
            <DialogContent>
                <BranchGoogleMaps
                    values={activeBranch}
                    setValues={setActiveBranch}
                    inputErr={inputErr}
                    setInputErr={setInputErr}
                    inputRef={place_id_ref}
                    onAddressAutofill={handlePlaceAutofill}
                />
                <Divider textAlign="left" sx={{ my: 3, fontWeight: '600' }}>
                    Información de la sucursal
                </Divider>
                <Grid container spacing={4}>
                    <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                        <div style={{
                            position: "relative",
                            width: "100%"
                        }}>
                            <img src={
                                    file ? URL.createObjectURL(file) : `${GOOGLE_DRIVE_CDN}${imgId}`
                                }
                                alt='imagen-sucursal'
                                style={{
                                    objectFit: 'contain',
                                    border: '1px solid #EAEDED',
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    width: "100%",
                                    height: "auto",
                                    zIndex: "1"
                                }}
                            />
                            {
                                file &&
                                <IconButton aria-label="delete"
                                    size="large"
                                    style={{
                                        color: 'gray',
                                        display: 'block',
                                        position: "absolute",
                                        top: "10%",
                                        left: "90%",
                                        transform: "translate(-50%, -50%)"
                                    }}
                                    onClick={ () => setFile('') }>
                                    <DeleteIcon fontSize="inherit" />
                                </IconButton>
                            }
                        </div>
                        
                        <div style={{ marginTop: '10px' }}>
                            <input
                                accept="image/*"
                                type="file"
                                id="select-image_suc"
                                name="images"
                                style={{ display: 'none' }} onChange={ handleChange }
                            />
                            <label htmlFor="select-image_suc">
                                <Button style={{ borderRadius: 0, textTransform: 'none' }}
                                    variant="contained"
                                    color="primary"
                                    component="span">
                                    Actualizar imagen
                                </Button>
                            </label>
                        </div>
                    </Grid>
                    <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                        <BranchInfo
                            values={activeBranch}
                            setValues={setActiveBranch}
                            inputErr={inputErr}
                            sharedRefs={sharedRefs}
                            inputChange={inputChange}
                        />
                    </Grid>
                </Grid>
                <Divider textAlign="left" sx={{ my: 3, fontWeight: '600' }}>Dirección</Divider>
                <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant='outlined'
                                label='Calle'
                                size='small'
                                name='address'
                                value={address}
                                error={address_err}
                                helperText={address_err ? "Ingrese la dirección de la sucursal" : ""}
                                inputRef={address_ref}
                                onChange={inputChange}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant='outlined'
                                label='Código postal'
                                size='small'
                                name='postalCode'
                                value={postalCode}
                                error={pc_err}
                                helperText={pc_err ? "Ingrese el código postal de la sucursal" : ""}
                                inputRef={postalCode_ref}
                                onChange={inputChange}
                                onBlur={handleInputBlur}
                            />
                        </FormControl>
                    </Grid>
                    {/* Colonia */}
                    {
                        colonies.length === 0 ?
                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        label="Colonia"
                                        size='small'
                                        name="colony"
                                        value={colony}
                                        error={colony_err}
                                        helperText={colony_err ? "Ingrese colonia de la sucursal" : ""}
                                        onChange={inputChange}
                                    />
                                </FormControl>
                            </Grid>
                            :
                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        size='small'
                                        name="colony"
                                        value={colony}
                                        error={colony_err}
                                        label="Colonia"
                                        select
                                        onChange={inputChange}
                                    >
                                        {
                                            colonies.map(({ nombre }) =>
                                                <MenuItem key={nombre}
                                                    value={nombre}>{nombre}
                                                </MenuItem>
                                            )
                                        }
                                    </TextField>
                                    {
                                        colony_err &&
                                        <FormHelperText sx={{ mx: 0 }}
                                            error={colony_err}>
                                            Ingrese colonia de la sucursal
                                        </FormHelperText>
                                    }
                                </FormControl>
                            </Grid>
                    }
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant='outlined'
                                label='Ciudad'
                                size='small'
                                name='city'
                                value={city}
                                error={city_err}
                                helperText={city_err ? "Ingrese la ciudad de la sucursal" : ""}
                                inputRef={city_ref}
                                disabled={cityInput}
                                onChange={inputChange}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant='outlined'
                                label='Estado'
                                size='small'
                                name='state'
                                value={state}
                                error={state_err}
                                helperText={state_err ? "Ingrese el estado de la sucursal" : ""}
                                inputRef={state_ref}
                                disabled={stateInput}
                                onChange={inputChange}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Divider textAlign="left" sx={{ my: 3, fontWeight: 'bold' }}>Redes sociales y google maps</Divider>
                <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant='outlined'
                                label='WhatsApp (número)'
                                size='small'
                                name='number'
                                value={number}
                                error={wsp_number_err}
                                helperText={wsp_number_err ? "Ingrese el número de WhatsApp" : ""}
                                inputRef={wsp_number_ref}
                                onChange={inputChange}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant='outlined'
                                label='Mensaje (Whatsapp)'
                                size='small'
                                name='message'
                                value={message}
                                error={wsp_message_err}
                                helperText={wsp_message_err ? "Ingrese el mensaje de WhatsApp" : ""}
                                inputRef={wsp_message_ref}
                                onChange={inputChange}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                variant='outlined'
                                label='Facebook (enlace)'
                                size='small'
                                name='url'
                                value={url}
                                error={facebook_url_err}
                                helperText={facebook_url_err ? "Ingrese el url de facebook" : ""}
                                inputRef={facebook_url_ref}
                                onChange={inputChange}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button onClick={ handleClose }>Cerrar</Button>
                <LoadingButton
                    onClick={ submit } autoFocus
                    endIcon={<EditIcon />}
                    loading={loading}
                    loadingPosition="end"
                    variant="contained">
                    Actualizar
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default EditBranch;
